import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  FeedbackState,
  FeedbackDetailState,
  FeedbackCategoriesState,
  AddFeedbackState,
} from './feedback.state';

export const selectFeedbacksState =
  createFeatureSelector<FeedbackState>('feedbacks');
export const selectFeedbackDetailState =
  createFeatureSelector<FeedbackDetailState>('feedbackDetail');
export const selectFeedbackCategoriesState =
  createFeatureSelector<FeedbackCategoriesState>('feedbackCategories');
export const selectAddFeedbackState =
  createFeatureSelector<AddFeedbackState>('addFeedback');

// Feedback List
export const selectFeedbacks = createSelector(
  selectFeedbacksState,
  (state: FeedbackState) => state.feedbacks || null,
);

export const selectFeedbacksLoading = createSelector(
  selectFeedbacksState,
  (state: FeedbackState) => state.loading,
);

export const selectFeedbacksError = createSelector(
  selectFeedbacksState,
  (state: FeedbackState) => state.error,
);

export const selectFeedbackParams = createSelector(
  selectFeedbacksState,
  (state: FeedbackState) => state.params,
);

// Feedback Detail
export const selectFeedback = createSelector(
  selectFeedbackDetailState,
  (state: FeedbackDetailState) => state.feedback,
);

export const selectFeedbackDetailLoading = createSelector(
  selectFeedbackDetailState,
  (state: FeedbackDetailState) => state.loading,
);

export const selectFeedbackDetailError = createSelector(
  selectFeedbackDetailState,
  (state: FeedbackDetailState) => state.error,
);

// Feedback Categories
export const selectFeedbackCategories = createSelector(
  selectFeedbackCategoriesState,
  (state) => state.categories,
);

export const selectFeedbackCategoriesLoading = createSelector(
  selectFeedbackCategoriesState,
  (state) => state.loading,
);

// Add Feedback
export const selectAddFeedbackLoading = createSelector(
  selectAddFeedbackState,
  (state) => state.loading,
);

export const selectAddFeedbackError = createSelector(
  selectAddFeedbackState,
  (state) => state.error,
);

export const selectAddFeedbackSuccess = createSelector(
  selectAddFeedbackState,
  (state) => state.success,
);
